import React, { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import {
  Typography,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Checkbox,
  Button,
  Snackbar
} from '@material-ui/core';
import MuiAlert from '@material-ui/lab/Alert';
import { BackdropCircular } from 'components';
import { verifyDNSConfigurationsApi } from 'api';
import { dnsData } from './dnsData';


const DNSManualSetup = () => {
  const dispatch = useDispatch();
  const { verifyingDNSConfigurations } = useSelector((state) => state.dns_manager);
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [isVerified, setIsVerified] = useState(true);

  const handleSaveToClipboard = (text) => {
    setOpenSnackbar(true);
    navigator.clipboard.writeText(text);
  };

  return (
    <div className="m-5">
      <Typography variant="h4" className="my-4 text-dark-gray">
        Instructions
      </Typography>
      <Typography variant="h6" className="mb-8 text-dark-gray">
        1. Add all of these records to your host’s DNS section.
      </Typography>
      <Table className="text-muted">
        <TableHead>
          <TableRow>
            <TableCell className="uppercase text-muted px-5 w-100">Type</TableCell>
            <TableCell className="uppercase text-muted px-5">Subdomain</TableCell>
            <TableCell className="uppercase text-muted px-5">Target</TableCell>
          </TableRow>
        </TableHead>
        <TableBody className="border-1-muted">
          {dnsData.map((config, index) => {
            const {type, subdomain, target} = config;
            return (
              <TableRow key={`dns-${index}`}>
                <TableCell className="text-muted px-5 border-1-muted">
                  {type}
                </TableCell>
                <TableCell className="border-1-muted">
                  <div className="text-muted flex items-center justify-between px-5">
                    {subdomain}
                    <Button
                      variant="outlined"
                      color="primary"
                      className="uppercase"
                      onClick={() => handleSaveToClipboard(subdomain)}
                    >
                      Copy
                    </Button>
                  </div>
                </TableCell>
                <TableCell className="border-1-muted">
                  <div className="text-muted flex items-center justify-between px-5">
                    {target}
                    <Button
                      variant="outlined"
                      color="primary"
                      className="uppercase"
                      onClick={() => handleSaveToClipboard(target)}
                    >
                      Copy
                    </Button>
                  </div>
                </TableCell>
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
      <Snackbar
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
        autoHideDuration={1000}
        onClose={() => setOpenSnackbar(false)}
        open={openSnackbar}
      >
        <MuiAlert elevation={6} variant="filled" severity="info">
          Copied to clipboard
        </MuiAlert>
      </Snackbar>
      <div className="mt-10 flex items justify-between">
        <Typography variant="h6" className="text-dark-gray">
          2. Once added, press Verify.
        </Typography>
        <div>
          <Checkbox
            color="primary"
            onChange={(e) => setIsVerified(!e.target.checked)}
          />
          <Typography variant="caption" className="text-14 text-muted mr-5">
            I&apos;ve added these records
          </Typography>
          <Button
            variant="contained"
            disabled={isVerified}
            color="primary"
            className="min-w-100 font-bold"
            onClick={() => verifyDNSConfigurationsApi({ dispatch })}
          >
            Verify
          </Button>
        </div>
      </div>
      <BackdropCircular loading={verifyingDNSConfigurations} title="Verifying DNS..." />
    </div>
  );
};

export default DNSManualSetup;
